var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "M15 17.5c-.125 0-.25 0-.375-.125l-13.75-5C.375 12.25 0 11.75 0 11.25s.375-1 .875-1.125l13.75-5c.25-.125.625-.125.875 0l13.75 5c.375.125.75.625.75 1.125s-.375 1-.875 1.125l-13.75 5c-.125.125-.25.125-.375.125zM4.875 11.25L15 14.875l10.125-3.625L15 7.625 4.875 11.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "M23.75 25H15c-.75 0-1.25-.5-1.25-1.25s.5-1.25 1.25-1.25h7.5c-.125-3.25-.875-6-2.125-8-.375-.624-.125-1.374.375-1.75.625-.374 1.375-.124 1.75.376 1.625 2.625 2.5 6.25 2.5 10.5C25 24.5 24.5 25 23.75 25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D3D3D3",
    d: "M15 25H6.25C5.5 25 5 24.5 5 23.75c0-4.25.875-7.875 2.5-10.5.375-.625 1.125-.75 1.75-.375s.75 1.125.375 1.75c-1.25 2-2 4.75-2.125 8H15c.75 0 1.25.5 1.25 1.25S15.75 25 15 25zm12.5 0c-.75 0-1.25-.5-1.25-1.25v-12.5c0-.75.5-1.25 1.25-1.25s1.25.5 1.25 1.25v12.5c0 .75-.5 1.25-1.25 1.25z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducationIcon);
export default __webpack_public_path__ + "static/media/educationIcon.df2a491e7d0bd178f296af3ab2a6325a.svg";
export { ForwardRef as ReactComponent };